export default __webpack_public_path__ + "static/media/home-texture.26ab660f.svg";